module.exports = __webpack_public_path__ + "img/ic-mepoint-coming-soon.png";